import { render, staticRenderFns } from "./BirdWatching.vue?vue&type=template&id=61645bff&scoped=true&"
import script from "./BirdWatching.vue?vue&type=script&lang=js&"
export * from "./BirdWatching.vue?vue&type=script&lang=js&"
import style0 from "./BirdWatching.vue?vue&type=style&index=0&id=61645bff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61645bff",
  null
  
)

export default component.exports